import React, { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";

import StyleRiskExposureDataTable from "./StyleRiskExposureDataTable";

import ActiveComponentContext from "../../../contexts/ActiveComponentContext";
import useOutputReportStore from "../../../store/OutputReport.store";

const StyleRiskExposureReport = () => {
  const reportName = "Style (Risk Exposure)";
  const data = useOutputReportStore((state) => state.data);
  const { active: activeId, setActive: setActiveComponent } = useContext(
    ActiveComponentContext
  );
  const { ref, entry } = useInView({
    /* Optional options */
    threshold: 0.25,
    trackVisibility: true,
    delay: 100,
  });

  useEffect(() => {
    if (entry?.isVisible && entry?.target?.id !== activeId) {
      setActiveComponent(entry.target.id);
    }
  }, [entry, setActiveComponent, activeId]);

  if (!data?.[reportName]) {
    return null;
  }

  return (
    <article ref={ref} id="StyleRiskExposure" className="report-article">
      <header className="section-title report-article__header">
        <h1>Style Risk Exposure[1]</h1>
      </header>

      <div className="report-article__content">
        <section className="report-article__visual">
          <StyleRiskExposureDataTable />
        </section>
      </div>
    </article>
  );
};

export default StyleRiskExposureReport;
